<div id="loader-wrapper">
  <div id="loader"></div>
</div>
